module.exports = __webpack_public_path__ + "img/渠村乡-c.c0f023a5.png";